enum FormModificationState {
    None = 0,
    Creating,
    Editing,
    Viewing
}

export { FormModificationState };
